import React from 'react';
import styles from './AddonsInsights.module.scss';
import { PriceFormat, Spinner } from 'components/UI';
import type { AddonsInsightsReport } from 'model/AddonsInsightsReport';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

interface Props {
    loading: boolean;
    report: AddonsInsightsReport;
}

const AddonsTable: React.FC<Props> = ({ loading, report }) => {
    const rows = report?.addons ?? [];

    return (
        <div className={styles.tableWrapper}>
            <div className={styles.tableHeaderRow}>
                <div>Add-On</div>
                <div>Category</div>
                <div className={styles.right}>Quantity</div>
                <div className={styles.right}>Avg Price</div>
                <div className={styles.right}>Gross Sales</div>
                <div className={styles.right}>Discounts</div>
                <div className={styles.right}>
                    Refunds
                    <Tooltip
                        content="Refunds are proportionally allocated from order-level refunds"
                        placement="top"
                        className={styles.customTooltip}
                    >
                        <div>
                            <FontAwesomeIcon
                                icon={faInfoCircle}
                                className={styles.tooltipIcon}
                            />
                        </div>
                    </Tooltip>
                </div>
                <div className={styles.right}>Net Sales</div>
                <div className={styles.right}>% of Net Add-On Sales</div>
                <div className={styles.right}>% of All Net Sales</div>
            </div>

            {loading ? (
                <div className={styles.loadingRow}>
                    <Spinner className={styles.spinner} />
                </div>
            ) : (
                rows.map((r, idx) => (
                    <div
                        key={(r.addonServiceId ?? r.addonName ?? 'row') + idx}
                        className={styles.addonRow}
                    >
                        <div>{r.addonName ?? '—'}</div>
                        <div>{r.category ?? '—'}</div>

                        <div className={styles.right}>{r.quantity ?? 0}</div>

                        <div className={styles.right}>
                            <PriceFormat price={Number(r.avgPrice ?? 0).toFixed(2)} />
                        </div>

                        <div className={styles.right}>
                            <PriceFormat price={Number(r.grossSales ?? 0).toFixed(2)} />
                        </div>

                        <div className={styles.right}>
                            <PriceFormat price={Number(r.discounts ?? 0).toFixed(2)} />
                        </div>

                        <div className={styles.right}>
                            <PriceFormat price={Number(r.refunds ?? 0).toFixed(2)} />
                        </div>

                        <div className={styles.right}>
                            <PriceFormat price={Number(r.netSales ?? 0).toFixed(2)} />
                        </div>

                        <div className={styles.right}>{(Number(r.netAddonsSalesPct ?? 0) * 100).toFixed(2)}%</div>
                        <div className={styles.right}>{(Number(r.allNetSalesPct ?? 0) * 100).toFixed(2)}%</div>
                    </div>
                ))
            )}
        </div>
    );
};

export default AddonsTable;
